import type { SpendInsightsRequestParams } from '../types/ReportSpendSummarySchema';

export const buildSpendInsightsBody = (
    params: SpendInsightsRequestParams,
    extras: Record<string, unknown> = {},
): Record<string, unknown> => ({
    dateFrom: params.dateFrom,
    dateTo: params.dateTo,
    ...(params.propertyIds?.length
        ? {
              propertyIds: params.propertyIds,
          }
        : {}),
    ...(params.categoryIds?.length
        ? {
              categoryIds: params.categoryIds,
          }
        : {}),
    ...(params.supplierIds?.length
        ? {
              supplierIds: params.supplierIds,
          }
        : {}),
    ...extras,
});
